module.exports = __webpack_public_path__ + "static/media/Statua_054.13b0729c.jpg";